/**
 * Labstep
 *
 * @module components/Filter/Tag/List
 * @desc Filter Tag List
 */

import FilterListHeader from 'labstep-web/components/Filter/List/Header';
import FilterListSearch from 'labstep-web/components/Filter/List/Search';
import { TagActionCreate } from 'labstep-web/components/Tag/Action/Create';
import { TagActionMenu } from 'labstep-web/components/Tag/Action/Menu';
import { ICONS } from 'labstep-web/constants/icons';
import type { Entity } from 'labstep-web/models/entity.model';
import { Tag } from 'labstep-web/models/tag.model';
import { PostFilterTag } from 'labstep-web/services/postFilter/filters/tag';
import type React from 'react';
import type { FilterTagListProps } from './types';

export const FilterTagList: React.FC<FilterTagListProps> = ({
  entityName,
  usePostFilter,
}) => (
  <FilterListSearch
    dataCy="components/Filter/Tag/List:list"
    params={{ type: entityName }}
    filter={{
      entityName,
      name: 'tag',
    }}
    action={
      <div style={{ marginBottom: 10 }}>
        <TagActionCreate
          defaultType={entityName}
          actionComponentProps={{
            type: 'text',
            icon: ICONS.entity.actions.create,
          }}
        />
      </div>
    }
    entityName={Tag.entityName}
    mapping={(entity: Entity) => ({
      icon: ICONS.tag.primary,
      text: (entity as Tag).name,
      params: { tag_id: entity.guid },
      postFilterValues: usePostFilter
        ? [PostFilterTag, [entity.guid]]
        : undefined,
      actionMenu: (
        <TagActionMenu
          actions={['edit', 'delete']}
          tag={entity as Tag}
        />
      ),
    })}
    searchBarProps={{
      viewComponent: (
        <FilterListHeader
          dataCy="components/Filter/Tag/List:header"
          header={'Tags'}
          filter={{
            entityName,
            name: 'tag',
          }}
        />
      ),
    }}
  />
);
